import { render, staticRenderFns } from "./view-customer.vue?vue&type=template&id=1324505e&scoped=true&"
import script from "./view-customer.vue?vue&type=script&lang=js&"
export * from "./view-customer.vue?vue&type=script&lang=js&"
import style0 from "./view-customer.vue?vue&type=style&index=0&id=1324505e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1324505e",
  null
  
)

export default component.exports